import { define } from 'wicked-elements';

define('[data-component="notification-toggle"]', {
  init() {
    this.input = this.element.querySelector('input[type="checkbox"]');
    this.status = this.element.querySelector('[data-status]');
    
    // Initially disable the toggle until OneSignal is ready
    this.input.disabled = true;
    this.status.textContent = 'Loading…';
    
    // Check if OneSignal is intentionally not loaded (no app ID)
    if (window.OneSignalFallback) {
      console.log('[NotificationToggle] OneSignal intentionally not loaded (no app ID), disabling component.');
      this.disableComponent();
      return;
    }
    
    window.OneSignalDeferred.push((OneSignal) => {
      // Run initial state update
      this.updateState();
      
      // Now enable the toggle since OneSignal is ready
      this.input.disabled = false;

      // Listen for future changes
      OneSignal.User.PushSubscription.addEventListener('change', () => {
        this.updateState();
      });
    });

    this.input.addEventListener('change', () => this.toggle());
  },

  disableComponent() {
    // Disable the toggle and update status
    this.input.disabled = true;
    this.input.checked = false;
    this.status.textContent = 'Push notifications unavailable';
    console.log('[NotificationToggle] Component disabled due to OneSignal unavailability.');
  },

  updateState() {
    window.OneSignalDeferred.push((OneSignal) => {
      const isSubscribed = OneSignal.User.PushSubscription.optedIn;
      this.input.checked = isSubscribed;
      this.status.textContent = isSubscribed ? 'Push notifications enabled' : 'Push notifications disabled';
    });
  },

  toggle() {
    window.OneSignalDeferred.push((OneSignal) => {
      const isSubscribed = OneSignal.User.PushSubscription.optedIn;
      if (isSubscribed) {
        OneSignal.User.PushSubscription.optOut();
      } else {
        // This will trigger the native prompt if permission is 'default'
        OneSignal.User.PushSubscription.optIn();
      }
    });
  }
});
